// src/services/authService.js
import apiClient from './apiClient.js'

export const authService = {
    async login(credentials) {
        const response = await apiClient.post('/auth/login', credentials)
        return response
    },

    async getCurrentUser() {
        const response = await apiClient.get('/auth/me')
        return response
    },
}